<template lang="pug">

    modal(ref='modal' v-bind:fullscreen="false")

        div(slot="header") Preise bearbeiten

        price-table-form(
            slot="content" ref='priceTableForm'
            v-bind:additional-cost-models='additionalCostModels'
            v-bind:job-models='jobModels'
            v-bind:offer-models='mutableOfferModels'
            v-bind:printings='printings'
            v-bind:price-models='priceModels'
            v-bind:supplier-models='supplierModels'
            v-on:input-offers='updateOfferModels'
        )

        action-row(v-on:cancel="closeModal()" v-on:save='persist()' slot="footer")

</template>

<script>
    import * as R from 'ramda'
    import PriceTableForm from './update-form-modal/PriceTableForm'
    import Modal from '@/components/app/Modal'
    import ActionRow from '@/components/form/ActionRow'

    export default {

        components: { ActionRow, Modal, PriceTableForm },

        created() {
            this.mutableOfferModels = R.clone(this.offerModels)
        },

        data() {
            return {
                mutableOfferModels: [],
            }
        },

        methods: {

            closeModal() {
                this.$refs.modal.close()
            },

            async persist() {
                try {
                    // Formular validieren
                    await this.$refs.priceTableForm.validate()

                } catch (_) {
                    // Formular noch invalid
                    return
                }

                try {
                    await Promise.all([

                        // Angebot speichern
                        this.persistOffers(),

                        // Preise speichern
                        this.$refs.priceTableForm.persist(),

                    ])

                    // Erfolgmeldung anzeigen
                    this.$growl.success('Preise wurden gespeichert')

                    // Modal closen
                    this.closeModal()

                } catch (e) {
                    // Fehlermeldung anzeigen
                    this.$growl.fatal('Preise konnten nicht gespeichert werden', e)
                }

            },

            async persistOffers() {
                return await R.compose(

                    // Promises zusammenfassen
                    // > [ Promise, Promise ]
                    // < Promise
                    promises => Promise.all(promises),

                    // Speichern
                    // > [ {  id: 1, status: 'PENDING', ... }, { id: 2, status: 'PENDING', ... } ]
                    // < [ Promise, Promise ]
                    R.map(model => this.$store.dispatch('offers/update', { model })),

                    // Status zu `PENDING` setzen
                    // > [ {  id: 1, status: 'FOO', ... }, { id: 2, status: 'BAR', ... } ]
                    // < [ {  id: 1, status: 'PENDING', ... }, { id: 2, status: 'PENDING', ... } ]
                    R.map(R.assoc('status', 'PENDING')),

                    // Abgelehnte Angebote nicht überschreiben
                    R.reject(R.propEq('status', 'DECLINED'))

                )(this.mutableOfferModels)
            },

            show() {
                this.$refs.modal.show()
            },

            updateOfferModels(models) {
                this.mutableOfferModels = models
            }

        },

        props: {

            additionalCostModels: {
                type: Array,
                required: true,
            },

            jobModels: {
                type: Array,
                required: true
            },

            offerModels: {
                type: Array,
                required: true
            },

            priceModels: {
                type: Array,
                required: true
            },

            printings: {
                type: Array,
                required: true
            },

            supplierModels: {
                type: Array,
                required: true
            },

        },

        watch: {

            offerModels(models) {
                this.mutableOfferModels = R.clone(models)
            },

        }

    }

</script>
